
        <ig-water-fall-container #waterfall [itemWidth]="300" [isAllItemsLoaded]="isAllDataLoaded"
                                 (onLoadMore)="loadMore($event)">
            <div *ngFor="let item of items" [ngStyle]="item.styles">
                {{item.value}}
            </div>
        </ig-water-fall-container>
    


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/fall.component.ts.FallComponent.html